import { httpClient } from "@coworker/http-client";

export const fetchCountriesWith4A1KData = async () => {
  return (
    (await httpClient.data.post<string[]>(`acesking/getAcesAndKingCountries`, {
      body: "",
    })) || [""]
  );
};
